/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7.5 3.38468C8.78211 2.51085 10.3314 2 12 2C16.4183 2 20 5.58172 20 10C20 11.5251 19.4257 12.8779 18.6664 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 3L5.43173 5.43173M20 20L16.4375 16.4375M16.4375 16.4375C16.3955 16.4731 16.3539 16.5079 16.3129 16.5418C15.5354 17.1853 15 18.1175 15 19.1268V19.1268C15 20.7136 13.7136 22 12.1268 22H11.8877C10.2929 22 9 20.7071 9 19.1123V19.1123C9 18.1102 8.47633 17.1838 7.70778 16.5408C6.2263 15.3013 4 12.9482 4 10C4 8.30167 4.52921 6.72694 5.43173 5.43173M16.4375 16.4375L5.43173 5.43173M9 18C9 18 10 18.5 12 18.5C14 18.5 15 18 15 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4 9.99991C4 13.6387 7.39142 16.371 8.58805 17.2217C8.84131 17.4018 9 17.6892 9 17.9999C9 17.9999 10 18.4999 12 18.4999C14 18.4999 15 17.9999 15 17.9999C15 17.6897 15.1626 17.4018 15.4171 17.2244C15.675 17.0446 16.0335 16.7795 16.4375 16.4374L5.43173 5.43164C4.52921 6.72685 4 8.30158 4 9.99991Z"
				fill="currentColor"
			/>
			<path
				d="M3 3L5.43173 5.43173M20 20L16.4375 16.4375M16.4375 16.4375C16.3955 16.4731 16.3539 16.5079 16.3129 16.5418C15.5354 17.1853 15 18.1175 15 19.1268V19.1268C15 20.7136 13.7136 22 12.1268 22H11.8877C10.2929 22 9 20.7071 9 19.1123V19.1123C9 18.1102 8.47633 17.1838 7.70778 16.5408C6.2263 15.3013 4 12.9482 4 10C4 8.30167 4.52921 6.72694 5.43173 5.43173M16.4375 16.4375L5.43173 5.43173M7.5 3.38468C8.78211 2.51085 10.3314 2 12 2C16.4183 2 20 5.58172 20 10C20 11.5251 19.4257 12.8779 18.6664 14M9 18C9 18 10 18.5 12 18.5C14 18.5 15 18 15 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.92239 4.00443C9.08394 3.21277 10.4868 2.75 12 2.75C16.0041 2.75 19.25 5.99594 19.25 10C19.25 11.3317 18.7489 12.5399 18.0452 13.5797C17.8131 13.9227 17.903 14.389 18.2461 14.6212C18.5891 14.8533 19.0554 14.7634 19.2875 14.4203C20.1026 13.2159 20.75 11.7185 20.75 10C20.75 5.16751 16.8325 1.25 12 1.25C10.176 1.25 8.48028 1.80893 7.07761 2.76493C6.73533 2.99822 6.64697 3.4648 6.88025 3.80707C7.11354 4.14935 7.58012 4.23771 7.92239 4.00443ZM3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L4.47382 5.53448C3.69648 6.84207 3.25 8.36976 3.25 10C3.25 13.3097 5.72304 15.8581 7.22652 17.116C7.86169 17.6475 8.25 18.3764 8.25 19.1123C8.25 21.1214 9.87865 22.75 11.8877 22.75H12.1268C14.1278 22.75 15.75 21.1278 15.75 19.1268C15.75 18.5426 15.9975 17.9615 16.4195 17.4801L19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303C20.8232 20.2374 20.8232 19.7626 20.5303 19.4697L16.9678 15.9072L5.96206 4.9014L3.53033 2.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 3L5.43173 5.43173M20 20L16.4375 16.4375M16.4375 16.4375C16.3955 16.4731 16.3539 16.5079 16.3129 16.5418C15.5354 17.1853 15 18.1175 15 19.1268V19.1268C15 20.7136 13.7136 22 12.1268 22H11.8877C10.2929 22 9 20.7071 9 19.1123V19.1123C9 18.1102 8.47633 17.1838 7.70778 16.5408C6.2263 15.3013 4 12.9482 4 10C4 8.30167 4.52921 6.72694 5.43173 5.43173M16.4375 16.4375L5.43173 5.43173M7.5 3.38468C8.78211 2.51085 10.3314 2 12 2C16.4183 2 20 5.58172 20 10C20 11.5251 19.4257 12.8779 18.6664 14M9 18C9 18 10 18.5 12 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 3L5.43173 5.43173M20 20L16.4375 16.4375M16.4375 16.4375C16.3955 16.4731 16.3539 16.5079 16.3129 16.5418C15.5354 17.1853 15 18.1175 15 19.1268V19.1268C15 20.7136 13.7136 22 12.1268 22H11.8877C10.2929 22 9 20.7071 9 19.1123V19.1123C9 18.1102 8.47633 17.1838 7.70778 16.5408C6.2263 15.3013 4 12.9482 4 10C4 8.30167 4.52921 6.72694 5.43173 5.43173M16.4375 16.4375L5.43173 5.43173M7.5 3.38468C8.78211 2.51085 10.3314 2 12 2C16.4183 2 20 5.58172 20 10C20 11.5251 19.4257 12.8779 18.6664 14M9 18C9 18 10 18.5 12 18.5C14 18.5 15 18 15 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M5.32857 4.26807L4.81638 5.00311C3.82905 6.42005 3.25 8.14361 3.25 10.0002C3.25 13.3098 5.72304 15.8583 7.22651 17.1162C7.86169 17.6476 8.25 18.3765 8.25 19.1125C8.25 21.1215 9.87865 22.7502 11.8877 22.7502H12.1268C14.1278 22.7502 15.75 21.128 15.75 19.1269C15.75 18.3876 16.1464 17.6533 16.7911 17.1198C17.0442 16.9103 17.2932 16.6958 17.544 16.4835L5.32857 4.26807Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 2.75C10.4868 2.75 9.08394 3.21277 7.92239 4.00443C7.58012 4.23771 7.11354 4.14935 6.88025 3.80707C6.64697 3.4648 6.73533 2.99822 7.07761 2.76493C8.48028 1.80893 10.176 1.25 12 1.25C16.8325 1.25 20.75 5.16751 20.75 10C20.75 11.7185 20.1026 13.2159 19.2875 14.4203C19.0554 14.7634 18.5891 14.8533 18.2461 14.6212C17.903 14.389 17.8131 13.9227 18.0452 13.5797C18.7488 12.5399 19.25 11.3317 19.25 10C19.25 5.99594 16.0041 2.75 12 2.75ZM2.46967 2.46967C2.76256 2.17678 3.23744 2.17678 3.53033 2.46967L5.96206 4.9014L16.9678 15.9072L20.5303 19.4697C20.8232 19.7626 20.8232 20.2374 20.5303 20.5303C20.2374 20.8232 19.7626 20.8232 19.4697 20.5303L15.9072 16.9678L4.9014 5.96206L2.46967 3.53033C2.17678 3.23744 2.17678 2.76256 2.46967 2.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
